import React, { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from '../routes';
import { AIPlaygroundProvider } from 'src/contexts/AIPlaygroundContext';
import { ErrorBanner } from 'src/common';
import { errorManager } from 'src/common/services';


export default function App() {
  const [globalError, setGlobalError] = useState<string | null>(null);

  useEffect(() => {
    const handleError = (error: string | null) => {
      setGlobalError(error);
    };

    errorManager.addListener(handleError);
    setGlobalError(errorManager.getCurrentError());

    return () => {
      errorManager.removeListener(handleError);
    };
  }, []);

  return (
    <BrowserRouter>
      <AIPlaygroundProvider>
        {globalError && (
          <ErrorBanner
            message={globalError}
            onDismiss={() => errorManager.clearError()}
          />
        )}
        <AppRoutes />
      </AIPlaygroundProvider>
    </BrowserRouter>
  );
}